import React from 'react';
import htmlParser from 'html-react-parser';

import { VideoComment } from '@edx/graphql/generated';
import { diffForHumans } from '@edx/helpers/datetime';
import { Body, Caption } from '@edx/components/typography';
import { Badge } from '@edx/components/badge';

type Props = Pick<VideoComment, 'author' | 'bodyHTML' | 'replies' | 'createdAt'>;

export const CommentItem: React.FC<Props> = ({ author, createdAt, bodyHTML }) => {
  const fullName = `${author.firstName} ${author.lastName}`;

  return (
    <article className="w-full flex space-x-2" data-testid="videoComments">
      <blockquote className="text-gray-600">
        <div className="flex space-x-2 mt-1">
          <div className="flex items-baseline space-x-2 justify-center font-body">
            <Body variant="semibold" className="leading-none text-gray-700">
              {fullName}
              {author.isStaff && <Badge className="ml-2 text-10px">Staff</Badge>}
            </Body>

            <Caption size="small" variant="semibold" className="leading-none text-gray-500">
              <time dateTime={createdAt}>Hace {diffForHumans(createdAt)}</time>
            </Caption>
          </div>
        </div>

        <Body tag="div" className="mt-2">
          {htmlParser(bodyHTML)}
        </Body>
      </blockquote>
    </article>
  );
};
